import { P3 } from '@repo/ui/components/Typography';
import { themeStyle } from '@repo/ui/theming';
import styled, { css } from 'styled-components';

interface Activable {
  isActive: boolean;
}

export const Label = styled(P3)<Activable>`
  color: ${({ isActive }) =>
    isActive ? themeStyle.varInkMain : themeStyle.varInkMedium};
  transition: color 0.3s;

  b {
    font-weight: ${themeStyle.fontSemiBold};
    line-height: 19px;
  }
`;

export const Price = styled(P3)<Activable>`
  color: ${({ isActive }) =>
    isActive ? themeStyle.varInkMain : themeStyle.varInkMedium};
  line-height: 140%;
  transition: color 0.3s;
  text-wrap: nowrap;
  b {
    font-size: ${themeStyle.fontSize16};
  }
`;

export const SaveBadge = styled.div`
  background: ${themeStyle.alertRed};
  height: 20px;
  padding: 0 8px;
  display: flex;
  align-items: center;
  border-radius: 360px;
  h6 {
    color: ${themeStyle.varBackgroundBase};
  }
`;

export const VariationWrapper = styled.div<
  Activable & { disabled: boolean; isNewThemeActive: boolean }
>`
  outline: ${({ isActive, isNewThemeActive }) => {
    if (isNewThemeActive) {
      return isActive
        ? `2px solid ${themeStyle.varBlueMedium}`
        : `1px solid ${themeStyle.varInkLight}`;
    }

    return isActive
      ? `2px solid ${themeStyle.varBrandMedium}`
      : `1px solid ${themeStyle.varInkLight}`;
  }};
  background: ${({ isActive, isNewThemeActive }) =>
    isActive
      ? isNewThemeActive
        ? themeStyle.varBlueLight
        : themeStyle.varBrandSuperLight
      : themeStyle.varBackgroundAlt};
  border: 2px solid ${themeStyle.varBackgroundAlt};

  transition: outline-color 0.3s;
  padding: 12px 24px;
  border-radius: ${themeStyle.radiusMedium};
  box-sizing: border-box;
  height: 68px;
  ${({ disabled, isNewThemeActive }) =>
    disabled
      ? ''
      : css`
          cursor: pointer;
          &:hover {
            outline-color: ${isNewThemeActive
              ? themeStyle.varBlueMedium
              : themeStyle.varBrandMedium};

            ${Label} {
              color: ${themeStyle.varInkMain};
            }

            ${Price} {
              color: ${themeStyle.varInkMain};
            }
          }
        `}
`;
